import React from 'react'
import AboutPage from '../components/about/AboutPage'

function About() {
    return (
        <div>
            <AboutPage />
        </div>
    )
}

export default About
